import { PropsCourseForm } from '@/domains/course/entities';
import * as yup from 'yup';

export const validateCourse = (props: PropsCourseForm) => {
  const schemaCourse = yup.object().shape({
    name: yup.string().required('Name is empty').trim(),
    shortName: yup.string().required('Short name is empty').trim(),
    description: yup.string().required('Description is empty').trim(),
    isActive: yup.boolean().required('Status is empty'),
    numberOfSession: yup
      .number()
      .required('Number of session is empty')
      .min(0, 'Number of session must be positive'),
    sessionHour: yup
      .number()
      .required('Session hour is empty')
      .min(0, 'Session hour must be positive'),
    optional: yup.boolean().required('Optional is empty'),
    courseLineForUpdate: yup.array(),
    courseTopic: yup.string().required('Course topic is empty').trim(),
    courseLine: yup.string().required('Course line is empty').trim(),
  });

  return { schemaCourse };
};
